import { render, staticRenderFns } from "./IntroductionContent.vue?vue&type=template&id=04bcdaba&"
import script from "./IntroductionContent.vue?vue&type=script&lang=ts&setup=true&"
export * from "./IntroductionContent.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04bcdaba')) {
      api.createRecord('04bcdaba', component.options)
    } else {
      api.reload('04bcdaba', component.options)
    }
    module.hot.accept("./IntroductionContent.vue?vue&type=template&id=04bcdaba&", function () {
      api.rerender('04bcdaba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town_translit]/vrach/[doctor_translit]/SectionPractice/common/IntroductionContent.vue"
export default component.exports